"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicySummary = void 0;
var core_money_1 = require("@newfront-insurance/core-money");
var core_ui_1 = require("@newfront-insurance/core-ui");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = __importDefault(require("react"));
var react_use_1 = require("react-use");
var update_policy_notes_1 = require("../../mutations/update-policy-notes");
var policy_stage_labels_1 = require("../../utils/policy-stage-labels");
var stringifyLinesOfCoverage_1 = require("../../utils/stringifyLinesOfCoverage");
var edit_policy_locs_modal_1 = require("../edit-policy-locs-modal");
var billing_details_modal_1 = require("./components/billing-details-modal");
var market_access_modal_1 = require("./components/market-access-modal");
function PolicySummary(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g;
    var policy = _a.policy, permissions = _a.permissions;
    var _h = react_use_1.useToggle(false), isBillingDetailsOpen = _h[0], toggleBillingDetails = _h[1];
    var _j = react_use_1.useToggle(false), isEditingLocs = _j[0], toggleEditingLocs = _j[1];
    var _k = react_use_1.useToggle(false), isViewingMarketAccess = _k[0], toggleViewMarketAccess = _k[1];
    var updateNotes = update_policy_notes_1.useUpdatePolicyNotes()[0];
    return (react_1.default.createElement(core_ui_1.Stack, { gap: 16, direction: "vertical" },
        react_1.default.createElement(core_ui_1.Text, { size: "extraLarge" }, "Policy summary"),
        react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Type", items: [(_c = (_b = policy.definition) === null || _b === void 0 ? void 0 : _b.readableName) !== null && _c !== void 0 ? _c : policy.type] }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Lines of coverage", items: [stringifyLinesOfCoverage_1.stringifyLinesOfCoverage(policy.linesOfCoverage)] }),
            (permissions === null || permissions === void 0 ? void 0 : permissions.canUpdateLinesOfCoverage) && (react_1.default.createElement(core_ui_1.TextLink, { weight: 600, underline: false, underlineOnHover: true, onClick: toggleEditingLocs }, "Edit lines of coverage")),
            react_1.default.createElement(edit_policy_locs_modal_1.EditPolicyLinesOfCoverageModal, { isOpen: isEditingLocs, onSubmitSuccess: toggleEditingLocs, onToggle: toggleEditingLocs, policy: policy })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Carrier", items: [((_e = (_d = policy.marketAccess) === null || _d === void 0 ? void 0 : _d.carrier) === null || _e === void 0 ? void 0 : _e.name) || '-'] }),
            react_1.default.createElement(core_ui_1.TextLink, { weight: 600, underline: false, underlineOnHover: true, onClick: toggleViewMarketAccess }, "View full market access information"),
            react_1.default.createElement(market_access_modal_1.MarketAccessModal, { isOpen: isViewingMarketAccess, onToggle: toggleViewMarketAccess, policy: policy })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Premium", items: [core_money_1.moneyToString(core_money_1.toMoneyOrUndefined(policy.billing.premium))] }),
            react_1.default.createElement(core_ui_1.TextLink, { weight: 600, underline: false, underlineOnHover: true, onClick: toggleBillingDetails }, "View billing details"),
            react_1.default.createElement(billing_details_modal_1.BillingDetailsModal, { isOpen: isBillingDetailsOpen, onToggle: toggleBillingDetails, policy: policy })),
        react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Effective dates", items: [
                string_formatters_1.CalendarDate.fromDate(policy.effectiveDate, 'UTC') + " - " + string_formatters_1.CalendarDate.fromDate(policy.expirationDate, 'UTC'),
            ] }),
        react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Policy term", items: [policy.policyTermMonths + " months"] }),
        react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Stage", items: [policy_stage_labels_1.policyStageLabelsMap[policy.stage]] }),
        react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Policy number", items: [(_f = policy.normalizedPolicyNumber) !== null && _f !== void 0 ? _f : '-'] }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Notes", items: [] }),
            react_1.default.createElement(core_ui_1.ToggleableTextarea, { defaultValue: (_g = policy.details.notes) !== null && _g !== void 0 ? _g : '', placeholder: "Add notes...", onSave: function (notes) { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, updateNotes({
                                    params: {
                                        policyUuid: (_a = policy.uuid) !== null && _a !== void 0 ? _a : '',
                                    },
                                    body: {
                                        notes: notes,
                                    },
                                })];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } }, function (_a) {
                var _b;
                var toggle = _a.toggle;
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(core_ui_1.Text, { color: "dark" }, (_b = policy.details.notes) !== null && _b !== void 0 ? _b : '-'),
                    (permissions === null || permissions === void 0 ? void 0 : permissions.canUpdateNotes) && (react_1.default.createElement(core_ui_1.TextLink, { weight: 600, underline: false, underlineOnHover: true, onClick: toggle }, "Edit notes"))));
            }))));
}
exports.PolicySummary = PolicySummary;
